import PropTypes from "prop-types";
import PhotoShape from "venuescanner-js/react/shapes/Photo";

const SpaceMinShape = PropTypes.shape({
  i: PropTypes.number.isRequired,
  lt: PropTypes.number.isRequired,
  lg: PropTypes.number.isRequired,
  vn: PropTypes.string.isRequired,
  nm: PropTypes.string.isRequired,
  // hasFlag: PropTypes.bool,
  // addedFlag: PropTypes.string,
  ps: PropTypes.arrayOf(PhotoShape.isRequired).isRequired,
});

export default SpaceMinShape;
